import React from 'react';

import classes from './IconButton.module.css';
import { IsStringEmpty } from '../../../utilities/CommonMethods';

// Props:
// styleclass = to define the specific classes to change how button looks
// margin = specify the margin for button
// padding = specify the padding for button
// icon = icon which we want on button
// altText = describing what the button is for
// label = to give label to button along with the icon
// clicked = to handle the onClick event


const iconButton = (props) => {
    let styleClasses = [classes.IconButton];

    if (props.styleclass !== undefined) {
        const styles = props.styleclass.split(' ');
        for (let style in styles) {
            styleClasses.push(classes[styles[style].trim()]);
        }
    }

    const width = props.width !== undefined ? props.width : 'auto';
    const margin = props.margin !== undefined ? props.margin : "0px 4px";
    const padding = props.padding !== undefined ? props.padding : "0.75em 1em";
    const fontSize = props.fontSize ? props.fontSize : '0.75em';
    const buttonId = props.buttonId ? props.buttonId : null;
    // const labelMarginTop = props.labelMarginTop ? props.labelMarginTop : "-11px";

    const iconStyles = {};
    if (!IsStringEmpty(props.iconWidth)) {
        iconStyles.width = props.iconWidth;
    }
    if (!IsStringEmpty(props.iconHeight)) {
        iconStyles.height = props.iconHeight;
    }

    const cursor = props.disabled ? 'not-allowed' : 'pointer';

    return (
        <div className={styleClasses.join(' ')} style={{ width: width, margin: margin, padding: padding, cursor: cursor }} onClick={props.clicked}>
            <img
                id={buttonId}
                className={classes.ButtonIcon}
                src={props.icon}
                alt={props.altText}
                style={iconStyles}
            />
            {props.label !== undefined
                ? <div className={classes.ButtonLabel} title={props.tooltip} style={{ fontSize: fontSize }}>
                    {props.label}
                </div>
                : null}
        </div>
    );
}

export default iconButton;